import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    root: {
      padding: [Spacings.s24, Spacings.s0, Spacings.s12],
    },
    // SKELETON
    rootFallback: {
      padding: [Spacings.s24, Spacings.s0, Spacings.s12],
      width: '100%',
      height: '100%',
    },
  }),
  {
    name: 'marketing-media',
  },
);

export default useStyles;
